// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"6a3987da","186":"e80dd835","225":"1f56e744","344":"22d068f4","372":"9ba0b933","377":"069821bb","738":"7952a5bb","841":"6c9a3525","856":"2ab8578c","858":"faf21490"}[chunkId] + ".chunk.js";
};